"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[545],{

/***/ 9910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ShareWidget": function() { return /* binding */ ShareWidget; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _images_social_facebook_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3869);
/* harmony import */ var _images_social_linkedin_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6505);
/* harmony import */ var _images_social_twitter_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1071);




const ShareWidget = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "animate-delay-1000 z-30 left-0 top-28 hidden lg:block py-3 w-8 bg-gray-100 rounded-2xl rounded-bl-none rounded-tl-none shadow-md animate-appear sm:fixed lg:py-4 lg:w-11 xl:left-auto xl:py-4 xl:w-12 xl:rounded-3xl xl:-translate-x-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                lang: "en_GB",
                className: "block text-center text-gray-600 text-xs tracking-tighter -translate-y-1/4 uppercase lg:text-sm",
                "aria-hidden": true,
                children: "Share"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                className: "flex flex-col gap-6 pl-1 pr-1.5 text-pink-500 lg:pl-2 lg:pr-3 xl:pl-3 xl:pr-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: `https://www.facebook.com/sharer.php?u=${encodeURIComponent(window.location.href)}`,
                            className: "block w-full hover:text-green-500 transition-colors",
                            title: "Udostępnij na Facebooku",
                            "aria-label": "Udostępnij na Facebooku",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_images_social_facebook_svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                className: "fill-current"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: `https://twitter.com/share?url=${encodeURIComponent(window.location.href)}&text=${encodeURIComponent(document.title)}&hashtags=typeofweb`,
                            className: "block w-full hover:text-green-500 transition-colors",
                            title: "Udostępnij na Twitterze",
                            "aria-label": "Udostępnij na Twitterze",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_images_social_twitter_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                className: "fill-current"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(window.location.href)}`,
                            className: "block w-full hover:text-green-500 transition-colors",
                            title: "Udostępnij na Linkedinie",
                            "aria-label": "Udostępnij na Linkedinie",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_images_social_linkedin_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                className: "fill-current"
                            })
                        })
                    })
                ]
            })
        ]
    });
};


/***/ })

}]);